import { Component, OnInit, ViewEncapsulation, Input } from '@angular/core';
import { Record } from '../../extract/models/record';

@Component({
	selector: 'app-recent-releases',
	templateUrl: './recent-releases.component.html',
	styleUrls: ['./recent-releases.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class RecentReleasesComponent implements OnInit {

	@Input() extractRecords: Array<Record>;
	@Input() releasesIsLoading: boolean;

	constructor() {		}

	ngOnInit() {

	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/dashboard/recent-releases/recent-releases.component.ts